<template>
  <v-list-item
    v-if="item"
    avatar
    class="task-list-tile"
    :class="{ 'task-list-tile-comment': !task }"
    @click="focus()"
  >
    <!--
    <v-list-item-avatar>
      <img src="https://randomuser.me/api/portraits/men/85.jpg">
    </v-list-item-avatar>
  -->
    <v-list-item-avatar v-show="isCheckable">
      <v-tooltip v-if="task && status" left open-delay="350">
        <template v-slot:activator="{ on }">
          <v-btn
            :color="status.color"
            absolute
            class="task-list-tile-check"
            dark
            fab
            flat
            right
            top
            @click.prevent.stop="nextStatus(status.by)"
            v-on="on"
          >
            <v-icon>{{ status.icon }}</v-icon>
            <!--
              panorama_fish_eye,
              done, done_all
            -->
          </v-btn>
        </template>

        <span
          ><b>{{ status.name }}</b
          ><template v-if="next_status">
            &mdash; Click here to set the status to<b>{{ next_status.name }}</b></template
          ></span
        >
      </v-tooltip>
    </v-list-item-avatar>

    <v-list-item-content>
      <!--
      <v-list-item-subtitle v-html="lorem"></v-list-item-subtitle>
      -->

      <div class="task-list-tile-text-container">
        <textarea
          ref="text"
          v-model="text"
          v-autosize="text"
          class="task-list-tile-text"
          placeholder="Update Text ..."
          spellcheck="false"
          :readonly="!editable"
          @focus="setEdit(true)"
          @blur="setEdit(false)"
        />

        <div class="task-list-tile-buttons">
          <template v-if="show_actions">
            <v-btn depressed small @click.prevent.stop="abort()">
              Abort
            </v-btn>
            <v-btn depressed small color="info" @click.prevent.stop="save()">
              Save
            </v-btn>
          </template>

          <v-btn v-if="editable" fab small dark flat color="red" @click.prevent.stop="remove()">
            <v-icon dark>
              {{ icons.cancel }}
            </v-icon>
          </v-btn>
        </div>
      </div>
      <div class="mt-2">
        {{ author }}
        <div v-if="task" class="task-list-tile-title-append">&mdash; {{ created_at }}</div>
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import TaskListItem from '@/components/task-components/task-list-item';
import get_avatar_initials from '@/utils/avatar-initials';
import { confirm } from '@/utils/modal';
import AuthorizationService from '@/services/AuthorizationService';
import { ROLES, UPDATE_TASK } from '@/config/constants';
import { intersection } from 'lodash';
import icons from '@/mixins/icons';

export default {
  components: {
    TaskListItem
  },
  mixins: [icons],
  props: {
    item: Object,
    type: String,
    isCheckable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      task: true,
      edit: false,
      backup: '',
      text: this.item.data.text,
      statuses: {
        to_do: {
          name: 'TO DO',
          color: 'pink',
          icon: this.icons.asPdf,
          by: [ROLES.CREATOR, ROLES.MANAGER, ROLES.ADMIN]
        },
        needs_approval: {
          name: 'Needs approval',
          color: 'blue',
          icon: this.icons.asPdf,
          by: [ROLES.MANAGER, ROLES.ADMIN]
        },
        done: {
          name: 'Done',
          color: 'green',
          icon: this.icons.asPdf,
          by: [ROLES.MANAGER, ROLES.ADMIN]
        }
      }
    };
  },
  mounted() {
    this.task = this.type !== 'comment';
    this.backup = '' + this.item_text;
  },
  computed: {
    ...mapState('users', {
      email: state => state.email
    }),
    ...mapState('slides', {
      active: state => state.active
    }),

    //

    status_list() {
      return Object.keys(this.statuses);
    },
    status() {
      var step = this.item.status ? this.item.status.step : null;
      if (step && this.statuses[step]) {
        return this.statuses[step];
      }
    },
    next_status() {
      var step = this.item.status ? this.item.status.step : null;
      if (step) {
        var index = this.status_list.indexOf(step);
        if (index !== -1 && index < this.status_list.length - 1) {
          var next = index + 1,
            step = this.status_list[next];
          return this.statuses[step];
        }
      }
    },

    //
    data() {
      var data = this.item.data;
      return data ? data : {};
    },
    id() {
      if (this.task) {
        return this.item._id;
      } else {
        return this.item.id;
      }
    },
    author() {
      if (this.task) {
        return this.data.author;
      } else {
        return this.item.author;
      }
    },
    item_text() {
      if (this.task) {
        return this.data.text;
      } else {
        return this.item.text;
      }
    },
    created_at() {
      if (this.task) {
        return moment(this.item.createdAt).fromNow();
      }
    },
    editable() {
      let auth = new AuthorizationService();
      return auth.isManager() || auth.isAdmin();
    },

    //
    is_admin() {
      let auth = new AuthorizationService();
      return auth.isAdmin();
    },
    changed() {
      return this.backup !== this.text;
    },
    show_actions() {
      return this.editable && (this.edit || this.changed);
    }
  },
  methods: {
    canUpdate(by) {
      return intersection(new AuthorizationService().getRoles(), by).length > 0;
    },
    async nextStatus(by) {
      if (!this.canUpdate(by)) return;
      const step = this.item.status ? this.item.status.step : null;
      if (step) {
        const index = this.status_list.indexOf(step);
        if (index !== -1 && index < this.status_list.length - 1) {
          const next = index + 1;
          this.item.status.step = this.status_list[next];
          await this.$store.dispatch(UPDATE_TASK, this.item);
        } else {
          this.item.status.step = this.status_list[0];
          this.item.reloopCount = this.item.reloopCount++;
          await this.$store.dispatch(UPDATE_TASK, this.item);
        }
      }
    },
    setEdit(edit) {
      this.edit = edit;
    },
    focus() {
      var el = this.$refs.text;
      if (el && el.focus) {
        el.focus();
      }
    },
    blur() {
      var el = this.$refs.text;
      if (el && el.blur) {
        el.blur();
      }
    },
    abort() {
      this.text = '' + this.backup;
      this.blur();
    },
    remove() {
      if (new AuthorizationService().isCreator()) return;
      var thing = this.task ? 'Task' : 'Kommentar';
      confirm(`Delete ${thing}`, `Are you sure you want to delete the task?`, 'Yes', 'No').then(yes => {
        if (yes) {
          this.$emit('delete', this.item);
        }
      });
    },
    save() {
      this.backup = '' + this.text;
      if (this.task) {
        this.data.text = '' + this.text;
      } else {
        // comment
        this.item.text = '' + this.text;
      }
      this.$emit('save', this.item);
      this.blur();
    },
    //
    me() {
      return this.avatar(this.email);
    },
    avatar: get_avatar_initials
  }
};
</script>
